import { createSlice, createAsyncThunk, SerializedError } from '@reduxjs/toolkit';
import axios from 'axios';

// Configure axios to send cookies
axios.defaults.withCredentials = true;

// Async thunk to initialize CSRF token
export const initializeCSRF = createAsyncThunk(
  'csrf/initializeCSRF',
  async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`,
      { withCredentials: true }
    );
    return response.data.csrfToken;
  }
);

// Define the shape of CSRF state
interface CsrfState {
  token: string | null;
  loading: boolean;
  error: SerializedError | null;
  initialized: boolean;
}

const initialState: CsrfState = {
  token: null,
  loading: false,
  error: null,
  initialized: false,
};

const csrfSlice = createSlice({
  name: 'csrf',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initializeCSRF.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(initializeCSRF.fulfilled, (state, action) => {
        state.token = action.payload;
        state.loading = false;
        state.initialized = true;
      })
      .addCase(initializeCSRF.rejected, (state, action) => {
        state.error = action.error;
        state.loading = false;
        state.initialized = false;
      });
  },
});

export const { clearError } = csrfSlice.actions;
export default csrfSlice.reducer;